import PropTypes from 'prop-types';

import Skeleton from '@zenbusiness/zui/Skeleton';

import NoSubscriptionsLanding from './NoSubscriptionsLanding';
import SubscriptionRow from './SubscriptionRow';

function BusinessEntitySubscriptions({
  businessEntity,
  serviceProductsMap,
  productsMap,
  loadingAllServices,
  loadingAllProducts,
  refetchSubscriptions,
}) {
  const { subscriptions } = businessEntity;

  if (!subscriptions || subscriptions.length === 0) {
    return <NoSubscriptionsLanding businessEntity={businessEntity} />;
  }

  if (loadingAllServices || loadingAllProducts) {
    return <Skeleton variant="rounded" height={120} data-testid="business-entity-subscriptions-skeleton" />;
  }

  return (
    <>
      {subscriptions.map((subscription) => (
        <SubscriptionRow
          key={subscription.orderBillingItemUuid}
          subscription={subscription}
          businessEntity={businessEntity}
          serviceProductsMap={serviceProductsMap}
          productsMap={productsMap}
          refetchSubscriptions={refetchSubscriptions}
        />
      ))}
    </>
  );
}

BusinessEntitySubscriptions.propTypes = {
  businessEntity: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    domesticJurisdiction: PropTypes.string.isRequired,
    subscriptions: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  serviceProductsMap: PropTypes.objectOf(
    PropTypes.shape({
      displayName: PropTypes.string,
      service: PropTypes.string,
    }),
  ),
  productsMap: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({}))),
  loadingAllServices: PropTypes.bool,
  loadingAllProducts: PropTypes.bool,
  refetchSubscriptions: PropTypes.func,
};

export default BusinessEntitySubscriptions;
